import type { WatermarkConfig } from '@/lib/campaign-watermark-types';

/** Which watermark a preview draws. A campaign watermark wins; a CPM-active
 *  library suppresses the default one (mirrors the backend renderLibrary
 *  override); only the default one is user-draggable. */
export function resolveWatermarkVisibility({
  showWatermark,
  campaignWatermark,
  cpmActive,
}: {
  showWatermark: boolean;
  campaignWatermark: WatermarkConfig | null;
  cpmActive: boolean;
}) {
  const effectiveShowWatermark = showWatermark && !cpmActive;
  return {
    campaignWatermark,
    effectiveShowWatermark,
    showDefaultWatermark: effectiveShowWatermark && !campaignWatermark,
  };
}
